module.exports = __webpack_public_path__ + "static/depot-doors-90ef027ba40983592bd14d9b1fc7f4a0.jpg";